<template>
    <dashboard>
        <row>
            <column size="col-10">
                <row>
                    <panel>
                        <h3 slot="title">Device</h3>

                        <value-table v-if="device">
                            <div class="value-table-row">
                                <h5>Model</h5>
                                <span>{{ device.model_name }}</span>
                            </div>
                            <div class="value-table-row">
                                <h5>OS Version</h5>
                                <span>{{ device.os_version }}</span>
                            </div>
                            <div class="value-table-row">
                                <h5>App Version</h5>
                                <span>{{ device.app_version }}</span>
                            </div>
                            <div class="value-table-row">
                                <h5>Push Notifications</h5>
                                <span>{{ device.token ? "Yes" : "No" }}</span>
                            </div>
                            <div v-if="device.type == 'ios'" class="value-table-row">
                                <h5>Location Services</h5>
                                <span>{{ permissionText }}</span>
                            </div>
                            <div v-if="device.type == 'ios'" class="value-table-row">
                                <h5>Bluetooth Permission</h5>
                                <span>{{ bluetoothText }}</span>
                            </div>
                        </value-table>

                        <app-alert v-else type="error">No device has been registered yet.</app-alert>
                    </panel>
                </row>
                <row>
                    <panel>
                        <h3 slot="title">Teams</h3>
                        <template slot="buttons">
                            <app-button size="small" @click="showTeamPicker = true">Add Team</app-button>
                        </template>
                        <team-table :items="teams" :columns="['name']"/>
                    </panel>
                </row>
            </column>
            <column size="col-14">
                <row>
                    <panel>
                        <h3 slot="title">Excuses</h3>
                        <template slot="buttons">
                            <app-button size="small" @click="showExcusePicker = true">Add Excuse</app-button>
                        </template>
                        <excuse-table :items="excuses" :columns="['name']">
                            <template slot="actions">
                                <el-table-column label="Actions" width="100px" align="right">
                                    <template slot-scope="scope">
                                        <app-tooltip effect="dark" content="Remove Excuse" placement="top-end">
                                            <app-button
                                                type="danger"
                                                size="mini"
                                                icon="icon-delete"
                                                @click.stop="removeExcuse(scope.$index, scope.row)">
                                                <span class="visuallyhidden">Remove Excuse</span>
                                            </app-button>
                                        </app-tooltip>
                                    </template>
                                </el-table-column>
                            </template>
                        </excuse-table>
                    </panel>
                </row>
            </column>
        </row>

        <team-picker v-model="showTeamPicker" @selected-team="assignTeam">
            <template slot="title">Select Team</template>
        </team-picker>

        <modal v-model="showExcusePicker" size="small">
            <excuse-edit-view :student="student" />
        </modal>
    </dashboard>
</template>

<script>
import StudentTable from '../Student/StudentTable'
import ValueTable from '../../ui/ValueTable'
import TeamTable from '../Team/TeamTable'
import ExcuseTable from './ExcuseTable'
import TeamPicker from '../Team/TeamPicker'
import ExcuseEditView from './ExcuseEditView'

export default {
    name: 'page-student-detail-information',
    components: {
        StudentTable,
        ValueTable,
        TeamTable,
        ExcuseTable,
        TeamPicker,
        ExcuseEditView
    },
    props: ['student'],
    data() {
        return {
            showTeamPicker: false,
            showExcusePicker: false
        }
    },
    computed: {
        device() { return this.student.device },
        excuses() { return this.student.excuses },
        teams() { return this.student.teams },
        permissionText() {
            switch (this.device.location_permission) {
            case 1:
                return 'While Using the App'
            case 2:
                return 'Always'
            default:
                return 'Never'
            }
        },
        bluetoothText() {
            switch (this.device.bluetooth_permission) {
            case 2:
                return 'On'
            default:
                return 'Off'
            }
        }
    },
    methods: {
        assignTeam({ id }) {
            this.student.$attach(id, 'teams', 'addStudentToTeam')
        },
        removeExcuse(index, excuse) {
            this.$confirm({
                title: 'Confirm',
                message: 'Are you sure you want to remove this excuse?'
            }).then(() => {
                excuse.$remove()
            })
        }
    }
}
</script>

<style lang="stylus"></style>
